import React, { useEffect, useState } from "react";
import { LoggedInView } from "../common/LoggedInView";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { getSettings, updateSettings, resetUpdateSettingsStatus } from "../../store/reducers/SystemSettingsSlice";
import { UpdateSystemSetting } from "../../models/SystemSetting";
import { RequestStatus } from "../../utils/Enums";
import Editor from 'react-simple-wysiwyg';
import SettingsCountryPicker from "../common/SettingsCountryPicker";
import SettingsDayPicker from "../common/SettingsDayPicker";

interface AdvertisingSettingsScreenProps {}

export const SystemSettingsScreen: React.FC<AdvertisingSettingsScreenProps> = () => {
    const dispatch = useAppDispatch();
    const settingsState = useAppSelector((state) => state.systemSettings);
    const [updatedSettings, setUpdatedSettings] = useState<any[]>([]);
    const [updated, setUpdated] = useState(false);
    const [showWarning, setShowWarning] = useState(true);

    useEffect(() => {
        dispatch(getSettings());
    }, [dispatch]);

    useEffect(() => {
        if (settingsState.updateSettingsStatus === RequestStatus.Success) {
            setUpdated(true);
            setTimeout(() => {
                setUpdated(false);
                dispatch(resetUpdateSettingsStatus());
            }, 3000);
        }
    }, [settingsState.updateSettingsStatus, dispatch]);

    const asType = (t: any): UpdateSystemSetting['type'] =>
        t === 'text' || t === 'wysiwyg' || t === 'toggle' || t === 'countryPicker' || t === 'dayPicker' ? t : 'text';

    const handleInputChange = (identifier: string, value: string) => {
        const index = updatedSettings.findIndex((setting) => setting.identifier === identifier);
        const setting = settingsState.settings.find((s) => s.identifier === identifier);

        if (index !== -1) {
            const updatedSettingsCopy = [...updatedSettings];
            updatedSettingsCopy[index] = { ...updatedSettingsCopy[index], value, type: asType(setting?.type), name: setting?.name || '' };
            setUpdatedSettings(updatedSettingsCopy);
        } else {
            setUpdatedSettings([
                ...updatedSettings,
                {
                    identifier,
                    value,
                    type: asType(setting?.type),
                    name: setting?.name || '',
                },
            ]);
        }
    };

    const handleToggleChange = (identifier: string, checked: boolean) => {
        const value = checked ? "true" : "false";
        handleInputChange(identifier, value);
    };

    const handleCountryChange = (identifier: string, countryIds: number[]) => {
        const value = JSON.stringify(countryIds);
        handleInputChange(identifier, value);
    };

    const handleDayChange = (identifier: string, dayIds: number[]) => {
        const value = JSON.stringify(dayIds);
        handleInputChange(identifier, value);
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        dispatch(updateSettings(updatedSettings));
    };

    return (
        showWarning ? (
            <div style={{ position: "fixed", top:0, left:0, width:"100%", height:"100%", backgroundColor:"rgba(0,0,0,0.85)", color:"white", display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", zIndex:9999 }}>
                <h1>Beware for here be dragons</h1>
                <p>Siin on süsteemsed seaded. Nende muutmine võib elogi töö halvata.</p>
                <button onClick={() => setShowWarning(false)} style={{ marginTop:"20px", padding:"10px 20px", fontSize:"16px" }}>Jätka</button>
            </div>
        ) : (
            <LoggedInView fullWidth={false}>
                {updated && (
                    <div style={{ marginBottom: "20px", padding: "10px", backgroundColor: "#dff0d8", color: "#3c763d", borderRadius: "4px" }}>
                        <div>
                            <h2 style={{ fontSize: "18px", margin: "0" }}>Seaded uuendatud</h2>
                        </div>
                    </div>
                )}
                {settingsState.errors.length > 0 && (
                    <div style={{ marginBottom: "20px", padding: "10px", backgroundColor: "#f2dede", color: "#a94442", borderRadius: "4px" }}>
                        <div>
                            <h2 style={{ fontSize: "18px", margin: "0" }}>Viga seadete uuendamisel</h2>
                            <ul style={{ margin: "10px 0 0 20px", padding: "0" }}>
                                {settingsState.errors.map((error, index) => (
                                    <li key={index} style={{ fontSize: "14px" }}>{error}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}
                <div className="form">
                    <h2 style={{ fontSize: "20px", margin: "0 0 15px 0" }}>
                        <span>Süsteemi seaded</span>
                    </h2>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                        {settingsState?.settings.map((setting) => (
                            <tr key={setting.identifier} style={{ marginBottom: "10px" }}>
                                <th style={{ padding: "10px", textAlign: "left", fontWeight: "normal", width: "200px" }}>{setting.name}:</th>
                                <td style={{ padding: "10px" }}>
                                    {setting.type === "wysiwyg" ? (
                                        <Editor
                                            value={
                                                updatedSettings.find((s) => s.identifier === setting.identifier)?.value ||
                                                setting.value
                                            }
                                            onChange={(e) => handleInputChange(setting.identifier, e.target.value)}
                                        />
                                    ) : setting.type === "toggle" ? (
                                        <input
                                            type="checkbox"
                                            name={setting.identifier}
                                            checked={
                                                (updatedSettings.find((s) => s.identifier === setting.identifier)?.value ||
                                                    setting.value) === "true"
                                            }
                                            onChange={(e) => handleToggleChange(setting.identifier, e.target.checked)}
                                        />
                                    ) : setting.type === "countryPicker" ? (
                                        <SettingsCountryPicker
                                            value={JSON.parse(
                                                updatedSettings.find((s) => s.identifier === setting.identifier)?.value ||
                                                setting.value ||
                                                "[]"
                                            )}
                                            onChange={(countryIds) => handleCountryChange(setting.identifier, countryIds)}
                                        />
                                    ) : setting.type === "dayPicker" ? (
                                        <SettingsDayPicker
                                            value={JSON.parse(
                                                updatedSettings.find((s) => s.identifier === setting.identifier)?.value ||
                                                setting.value ||
                                                "[]"
                                            )}
                                            onChange={(dayIds) => handleDayChange(setting.identifier, dayIds)}
                                        />
                                    ) : (
                                        <input
                                            type="text"
                                            name={setting.identifier}
                                            style={{ width: "100%", padding: "5px", fontSize: "14px" }}
                                            value={
                                                updatedSettings.find((s) => s.identifier === setting.identifier)?.value ||
                                                setting.value
                                            }
                                            onChange={(e) => handleInputChange(setting.identifier, e.target.value)}
                                        />
                                    )}
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <th></th>
                            <td style={{ padding: "10px" }}>
                                <button
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                      <span>
                        <strong>Muuda</strong>
                      </span>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </LoggedInView>
        )
    );
};